import { render, staticRenderFns } from "./XpressPayDataSubscription.vue?vue&type=template&id=1c42616f&scoped=true"
import script from "./XpressPayDataSubscription.vue?vue&type=script&lang=js"
export * from "./XpressPayDataSubscription.vue?vue&type=script&lang=js"
import style0 from "./XpressPayDataSubscription.vue?vue&type=style&index=0&id=1c42616f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c42616f",
  null
  
)

export default component.exports